// removed by extract-text-webpack-plugin
module.exports = {"content":"content_2cEnC","header":"header_w1gyq","inner":"inner_XCbZm","innerNoPadding":"innerNoPadding_1XB-O","anchorBottom":"anchorBottom_ytQBB","children":"children_2J4R1","actions":"actions_9fd2x"};


//////////////////
// WEBPACK FOOTER
// ./app/components/sidebar-content/styles.scss
// module id = 501
// module chunks = 1